<div
	class="row"
	*ngIf="presenceupdate">
	<div class="col-md-9">
		<h3 class="text-bold">
			{{ presenceupdate.start}} - {{ presenceupdate.stop }}
		</h3>
	</div>

	<div class="col-md-3 text-right">

		<div
			role="group"
			class="btn-group">
			<button
				type="button"
				(click)="prev(moveModal)"
				class="btn btn-primary py-2">
				<i class="fas fa-caret-left fa-lg"></i>
			</button>
			<button
				type="button"
				(click)="next(moveModal)"
				class="btn btn-primary py-2">
				<i class="fas fa-caret-right fa-lg"></i>
			</button>
		</div>
	</div>
</div>
<br>
<table
	class="table"
	*ngIf="presenceupdate">
	<tbody>
		<tr>
			<th class="not-editable large-col"></th>
			<th class="not-editable large-col">
				{{presenceupdate.totalline.projectname}}
			</th>
			<th
				class="not-editable"
				*ngFor="let d of presenceupdate.totalline.days">
				{{d.value}}
			</th>
		</tr>
		<tr>
			<th class="not-editable large-col">Progetto</th>
			<th class="not-editable large-col">Att.</th>
			<th
				class="not-editable"
				[class.festive]="d.isFestive"
				*ngFor="let d of presenceupdate.totalline.days">
				{{d.day}} {{d.humandate}}
			</th>
		</tr>
		<tr *ngFor="let l of presenceupdate.standardlines">
			<td class="not-editable large-col">
				<div [ngbTooltip]="l.projectname">{{l.projectname}}</div>
			</td>
			<td class="not-editable large-col">
				<div [ngbTooltip]="l.activityname">{{l.activityname}}</div>
			</td>
			<td
				[class.not-editable]="!d.editable"
				*ngFor="let d of l.days">
				<ng-template [ngIf]="d.editable">
					<input
						[(ngModel)]="d.value"
						(change)="edited = true"
						(focusout)="changed(d)"
						min="0"
						type="number"
						name="{{l.projectname}}-{{l.activityname}}-{{d.humandate}}-value">
				</ng-template>
				<ng-template [ngIf]="!d.editable">NA</ng-template>
			</td>
		</tr>
		<tr>
			<th class="not-editable large-col"></th>
			<th class="not-editable large-col">TOTALE</th>
			<th
				class="not-editable"
				[class.valid]="presenceupdate.valid(d.humandate)"
				[class.invalid]="!presenceupdate.valid(d.humandate)"
				*ngFor="let d of presenceupdate.totalline.days">
				{{presenceupdate.getTotal(d.humandate)}}
			</th>
		</tr>
	</tbody>
</table>

<ng-template [ngIf]="!loading">
	<div *ngFor="let d of this.presenceupdate.invaliddays">
		{{"labels.invalid-day-presenceupdate" | translate: { day : d } }}
	</div>
</ng-template>

<div
	class="modal-footer"
	*ngIf="!loading">

	<button
		type="button"
		class="btn btn-secondary"
		(click)="cancel()">
		{{'labels.cancel' | translate}}
	</button>
	<button
		type="button"
		[disabled]="!edited || !presenceupdate.isValid"
		(click)="save()"
		class="btn btn-primary">
		{{'labels.save' | translate}}
	</button>
</div>

<ng-template
	#moveModal
	let-modal>
	<div class="modal-header">
		<h4
			class="modal-title"
			id="modal-basic-title">
			{{'labels.warning' | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div class="modal-body">

		<div class="media">
			<span class="align-self-start mr-3 icon ng-star-inserted">
				<i class="fa fa-exclamation-triangle fa-lg text-warning"></i>
			</span>
			<div class="media-body">
				{{(presenceupdate.isValid ?  "labels.warning-presenceupdate-save" : "labels.warning-presenceupdate-save-invalid") | translate}}
			</div>
		</div>

	</div>
	<div class="modal-footer">
		<button
			*ngIf="presenceupdate.isValid"
			type="button"
			ngbautofocus
			class="btn btn-warning"
			(click)="save()">
			{{"labels.warning-presenceupdate-save-confirm" | translate}}
		</button>
		<button
			type="button"
			ngbautofocus
			class="btn btn-warning"
			(click)="moveWithoutSave()">
			{{"labels.warning-presenceupdate-save-invalid-confirm" | translate}}
		</button>
		<button
			type="button"
			class="btn btn-default ng-star-inserted"
			(click)="dismiss()">
			{{"labels.warning-presenceupdate-save-invalid-cancel" | translate}}
		</button>
	</div>
</ng-template>
